/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submitting_Ad_JobInputs */



/**
* | output |
* | --- |
* | "Submitting job for processing..." |
*
* @param {Submitting_Ad_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submitting_ad_job = /** @type {((inputs?: Submitting_Ad_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submitting_Ad_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soumission de la tâche pour traitement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auftrag wird zur Bearbeitung übermittelt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invio della richiesta di elaborazione in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправка задания на обработку...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviando trabajo para su procesamiento...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在提交作业进行处理……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理のためにジョブを送信しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रक्रिया के लिए कार्य प्रस्तुत किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviando trabalho para processamento...")
	return /** @type {LocalizedString} */ ("Submitting job for processing...")
});